<template>
  <div>
    <el-dialog
      ref="matchSignDialog"
      v-dialogDrag
      title="直播参与人员匹配零售户档案"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogConnectForm"
        :model="dialogConnectForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="用户ID">
                  <el-input
                    v-model="dialogViewForm.uid"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="昵称">
                  <el-input
                    v-model="dialogViewForm.nickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="绑定本香手机号">
                  <el-input
                    v-model="dialogViewForm.bxPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="区域">
                  <el-input
                    v-model="dialogViewForm.area"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            睿零售用户清单
          </h3>
          <div class="modal-row-box">
            <div class="searchCondition">
              <el-row :gutter="10">
                <el-col :span="3">
                  <el-input
                    v-model="tableQuery.likeName"
                    placeholder="用户姓名"
                    clearable
                    @keyup.enter.native="searchTableData"
                  />
                </el-col>
                <el-col :span="4">
                  <el-input
                    v-model="tableQuery.likePhone"
                    placeholder="联系电话"
                    clearable
                    @keyup.enter.native="searchTableData"
                  />
                </el-col>
                <el-col :span="4">
                  <el-input
                    v-model="tableQuery.likeStoreName"
                    placeholder="门店名称"
                    clearable
                    @keyup.enter.native="searchTableData"
                  />
                </el-col>
                <el-col :span="4">
                  <el-input
                    v-model="tableQuery.likeCertificateNo"
                    placeholder="专卖证号"
                    clearable
                    @keyup.enter.native="searchTableData"
                  />
                </el-col>
                <el-col :span="2">
                  <el-button
                    type="primary"
                    @click="searchTableData"
                  >
                    查询
                  </el-button>
                </el-col>
                <el-col
                  :span="7"
                  style="color: red; font-weight: 700;"
                >
                  <div style="margin-top: 8px;">
                    一次最多查询{{ tableQuery.limit }}条记录，所以请尽量完善查询条件
                  </div>
                </el-col>
              </el-row>
            </div>

            <el-table
              :data="appUserDataList"
              border
              stripe
              :header-cell-style="{background:theme()}"
              style="width: 100%; margin: 5px 0;"
              height="310"
              class="connect-app-user-table"
            >
              <el-table-column
                label="选择"
                align="center"
                width="55"
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="currentRow"
                    :label="scope.$index"
                    @change.native="getCurrentRow(scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-for="(column, index) in appUserTableColumns"
                :key="index"
                resizable
                show-overflow-tooltip
                :width="column.width ? column.width : ''"
                :label="column.label"
                :prop="column.prop"
                :align="column.align || ''"
                header-align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row[column.prop] }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 小程序用户API
import { listAppUserApi } from '@/api/v2/appUser';
// 直播活动参与人员API
import { viewLiveStreamingEventDetailApi, matchingStoreLiveStreamingEventDetailApi } from '@/api/v2/liveStreamingEventDetail'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
      dialogConnectForm: {},

      tableQuery: {
        likeName: '',
        likePhone: '',
        likeStoreName: '',
        likeCertificateNo: '',
        type: 1,
        limit: 500
      },
      appUserTableColumns: [
        { label: 'OpenID', prop: 'wxOpenId', width: 150 },
        { label: '省区', prop: 'provinceName', width: 80 },
        { label: '城市', prop: 'cityName', width: 80 },
        { label: '姓名', prop: 'name', width: 80 },
        { label: '联系电话', prop: 'phone', width: 100 },
        { label: '店名', prop: 'storeName', width: 150 },
        { label: '店主', prop: 'ownerName', width: 80 },
        { label: '专卖证号', prop: 'certificateNo', width: 110 },
        { label: '本香门店编码', prop: 'benxiangStoreNo', width: 125 },
        { label: '状态', prop: 'statusValue', width: 65, align: 'center' },
      ],
      appUserDataList: [],
      currentRow: null,
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {};
        _this.dialogConnectForm = {
          id: '',
          appUserId: ''
        }
        _this.tableQuery = {
          likeName: '',
          likePhone: '',
          likeStoreName: '',
          likeCertificateNo: '',
          provinceId: 0,
          type: 1,
          limit: 500
        }
        _this.appUserDataList = [];
        _this.currentRow = null;

        _this.loadLiveStreamingEventDetailData();

        _this.$nextTick(() => {
          _this.$refs.dialogConnectForm.clearValidate()
        })
      }
    }
  },
  methods: {
    theme () {
      return '#0076ff'
    },
    // 加载数据
    loadLiveStreamingEventDetailData () {
      let _this = this;
      viewLiveStreamingEventDetailApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogViewForm = data;
        _this.dialogConnectForm.id = data.id

        _this.tableQuery.provinceId = data.provinceId
        _this.tableQuery.likePhone = data.bxPhone || ''
        if (_this.tableQuery.likePhone) {
          _this.searchTableData();
        }
      })
    },
    // 查询零售户档案列表
    searchTableData () {
      let _this = this;
      if (!_this.tableQuery.likeName && !_this.tableQuery.likeCertificateNo && !_this.tableQuery.likeStoreName && !_this.tableQuery.likePhone) {
        _this.$message({ message: '请输入查询条件后获取睿零售用户列表', type: 'error' })
        return
      }

      listAppUserApi(_this.tableQuery).then((response) => {
        const { data } = response;
        _this.appUserDataList = data || [];
      }).catch(() => { })
    },
    getCurrentRow (row) {
      let _this = this;
      _this.dialogConnectForm.appUserId = row.id;
    },
    // 保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogConnectForm.validate(valid => {
        if (valid) {
          _this.$confirm('是否确认关联选择的睿零售注册用户?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            matchingStoreLiveStreamingEventDetailApi(_this.dialogConnectForm).then(() => {
              _this.$message({ message: '关联睿零售用户成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogConnectForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
  }
}

.searchCondition {
  .el-col {
    min-height: 28px;
  }
  margin: 5px 0;
}

.connect-app-user-table {
  // radio label隐藏不显示
  ::v-deep .el-radio__label {
    display: none;
  }

  .img-size {
    width: 62px;
    height: 62px;
    vertical-align: middle;
  }
}
</style>
